import React, { useContext, useEffect, useState } from 'react';
import { ScrollPosition }                         from '../../container/site-layout/site-layout';

export const useParallax = (ref: React.MutableRefObject<any>) => {
    const [ parallax, setParallax ] = useState(0);
    const scroll = useContext(ScrollPosition);

    useEffect(() => {
        if (window) {
            const windowHeight = window.innerHeight;
            const windowScroll = scroll;
            const wrapperTop = ref.current.offsetTop;
            const wrapperHeight = ref.current.clientHeight;
            const imageHeight = ref.current.children[ 0 ].clientHeight;

            if ((windowHeight + windowScroll) > wrapperTop) {
                if ((windowHeight + windowScroll) < wrapperTop + wrapperHeight + windowHeight) {
                    const finish = imageHeight - wrapperHeight;
                    // const percent = ((windowHeight + ref.current.getBoundingClientRect().top)) / (wrapperTop + wrapperHeight + windowHeight);
                    const percent = ((windowHeight + (windowScroll - wrapperTop))) / (wrapperTop + wrapperHeight + windowHeight);
                    // console.log('windowScroll', windowScroll);
                    // console.log('wrapperTop', wrapperTop);
                    const val = percent * finish;

                    // const val2 =
                    // console.log(windowScroll, wrapperTop, ref.current.getBoundingClientRect().top - windowHeight);
                    // console.log(windowScroll, wrapperTop, ref.current.getBoundingClientRect().top - windowHeight);
                    // console.log(val, 'image height -', imageHeight);
                    // return setParallax((ref.current.getBoundingClientRect().top - windowHeight) * -0.5);
                    // console.log(val);
                    return setParallax(val);
                }
            }
        }
    }, [ scroll ]);
    return [ parallax ];
};
